export const g670 = '#002929';
export const g600 = '#003737';
export const g500 = '#004c4c';
export const g400 = '#005e5d';
export const g300 = '#00716b';
export const g200 = '#00857a';
export const g100 = '#37aba1';
export const g75 = '#86d1cd';
export const g65 = '#ade0df';
export const g55 = '#d8f0ef';
export const g50 = '#edf7f7';
export const y500 = '#e6b400';
export const y400 = '#f3c000';
export const y300 = '#ffd200';
export const y200 = '#ffe263';
export const y100 = '#ffea8f';
export const y75 = '#fff2ba';
export const y65 = '#fff6cc';
export const y55 = '#fff9de';
export const y50 = '#fffbe6';
export const gm500 = '#2d4d4d';
export const gm400 = '#3c5e5e';
export const gm300 = '#4f706f';
export const gm200 = '#668582';
export const gm100 = '#91aba9';
export const gm75 = '#c0d1d0';
export const gm65 = '#d3e0e0';
export const gm55 = '#e9f0f0';
export const gm50 = '#f2f7f7';
export const n670 = '#222';
export const n500 = '#4d4d4d';
export const n400 = '#666';
export const n300 = '#808080';
export const n200 = '#999';
export const n100 = '#b3b3b3';
export const n75 = '#ccc';
export const n65 = '#dedede';
export const n55 = '#f0f0f0';
export const n50 = '#f9f9f9';
export const white = '#fff';
export const positive500 = '#3f6212';
export const positive400 = '#4d7c0f';
export const positive300 = '#65a30d';
export const positive200 = '#84cc16';
export const positive100 = '#a3e635';
export const positive75 = '#bef264';
export const positive65 = '#d9f99d';
export const positive55 = '#ecfccb';
export const positive50 = '#f7fee7';
export const info500 = '#075985';
export const info400 = '#0369a1';
export const info300 = '#0284c7';
export const info200 = '#0ea5e9';
export const info100 = '#38bdf8';
export const info75 = '#7dd3fc';
export const info65 = '#bae6fd';
export const info55 = '#e0f2fe';
export const info50 = '#f0f9ff';
export const negative500 = '#991b1b';
export const negative400 = '#b91c1c';
export const negative300 = '#dc2626';
export const negative200 = '#ef4444';
export const negative100 = '#f87171';
export const negative75 = '#fca5a5';
export const negative65 = '#fecaca';
export const negative55 = '#fee2e2';
export const negative50 = '#fef2f2';
export const warning500 = '#9a3412';
export const warning400 = '#c2410c';
export const warning300 = '#ea580c';
export const warning200 = '#f97316';
export const warning100 = '#fb923c';
export const warning75 = '#fdba74';
export const warning65 = '#fed7aa';
export const warning55 = '#ffedd5';
export const warning50 = '#fff7ed';
export const privacy500 = '#6b21a8';
export const privacy400 = '#7e22ce';
export const privacy300 = '#9333ea';
export const privacy200 = '#a855f7';
export const privacy100 = '#c084fc';
export const privacy75 = '#d8b4fe';
export const privacy65 = '#e9d5ff';
export const privacy55 = '#f3e8ff';
export const privacy50 = '#faf5ff';
